import { trackEvent } from '@/lib/analytics'
import { homepageBannerParams } from '@/lib/analytics/bannerEventParams'

/** Banner links open in a new tab, so the resulting page_view cannot be attributed to the banner. */
export function trackHomepageBannerClick(bannerId: number, index: number, url: string): void {
  const host = typeof window === 'undefined' ? undefined : window.location.hostname
  const params = homepageBannerParams(bannerId, index, url, host)
  if (params) trackEvent('homepage_banner_click', params)
}
